import _isUndefined from "lodash/isUndefined";
import _nth from "lodash/nth";

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { TextField } from '@nextiva/next-ui';
import ColumnFilter from "../ColumnFilter";
import ColumnSearch from "../ColumnSearch";
import { mapNullValues, mapEmptyOperator } from "../dataMappers/incoming";
import { formatNullValues, formatEmptyOperator } from "../dataMappers/outgoing";

var NumericColumn =
/*#__PURE__*/
function (_Component) {
  _inherits(NumericColumn, _Component);

  function NumericColumn() {
    var _ref;

    var _temp, _this;

    _classCallCheck(this, NumericColumn);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _possibleConstructorReturn(_this, (_temp = _this = _possibleConstructorReturn(this, (_ref = NumericColumn.__proto__ || Object.getPrototypeOf(NumericColumn)).call.apply(_ref, [this].concat(args))), _initialiseProps.call(_assertThisInitialized(_this)), _temp));
  }

  _createClass(NumericColumn, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          operatorOptions = _props.operatorOptions,
          onOperatorChange = _props.onOperatorChange,
          operator = _props.operator,
          onSelectFocus = _props.onSelectFocus;
      return React.createElement(ColumnFilter, {
        onOperatorChange: onOperatorChange,
        options: operatorOptions,
        operator: operator,
        onFocus: onSelectFocus
      }, this.renderPicker());
    }
  }]);

  return NumericColumn;
}(Component);

Object.defineProperty(NumericColumn, "defaultOperator", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: function value() {
    return 'lt';
  }
});
Object.defineProperty(NumericColumn, "getOperatorOptions", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: function value(_ref2) {
    var _ref2$title = _ref2.title,
        title = _ref2$title === void 0 ? 'Value' : _ref2$title;
    return [{
      value: 'lt',
      label: "".concat(title, " Is less than")
    }, {
      value: 'gt',
      label: "".concat(title, " is greater than")
    }, {
      value: 'eq',
      label: "".concat(title, " is equal to")
    }, {
      value: 'lte',
      label: "".concat(title, " is less than or equal to")
    }, {
      value: 'gte',
      label: "".concat(title, " is greater than or equal to")
    }, {
      value: 'neq',
      label: "".concat(title, " is not equal to")
    }, {
      value: 'between',
      label: "".concat(title, " is between")
    }, {
      value: 'empty',
      label: 'Is Empty'
    }, {
      value: 'notEmpty',
      label: 'Is not Empty'
    }];
  }
});
Object.defineProperty(NumericColumn, "validate", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: function value(_ref3) {
    var operator = _ref3.operator,
        values = _ref3.values;

    var startValue = _nth(values, 0);

    var endValue = _nth(values, 1);

    var hasBothValues = !_isUndefined(startValue) && !_isUndefined(endValue);

    if (!hasBothValues || operator !== 'between') {
      return {
        error: false
      };
    }

    if (endValue < startValue) {
      return {
        error: true,
        nextState: {
          operator: 'between',
          values: [startValue]
        }
      };
    }
  }
});
Object.defineProperty(NumericColumn, "mapIncomingFilters", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: function value() {
    return mapEmptyOperator(mapNullValues.apply(void 0, arguments));
  }
});
Object.defineProperty(NumericColumn, "mapOutgoingFilters", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: function value() {
    var _formatEmptyOperator = formatEmptyOperator(formatNullValues.apply(void 0, arguments)),
        operator = _formatEmptyOperator.operator,
        values = _formatEmptyOperator.values;

    var startValue = _nth(values, 0);

    var endValue = _nth(values, 1);

    if (operator !== 'between') {
      return {
        operator: operator,
        values: values
      };
    }

    if (!_isUndefined(startValue) && _isUndefined(endValue)) {
      return {
        operator: 'gt',
        values: [startValue]
      };
    } else if (_isUndefined(startValue) && !_isUndefined(endValue)) {
      return {
        operator: 'lt',
        values: [endValue]
      };
    }

    return {
      operator: operator,
      values: values
    };
  }
});
Object.defineProperty(NumericColumn, "propTypes", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: {
    values: PropTypes.array,
    operator: PropTypes.string,
    onOperatorChange: PropTypes.func.isRequired,
    onFilterChange: PropTypes.func.isRequired,
    title: PropTypes.string,
    isNullTypeOperator: PropTypes.bool,
    onKeyDown: PropTypes.func,
    onSelectFocus: PropTypes.func
  }
});

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  Object.defineProperty(this, "handleFilterChange", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: function value(type) {
      return function (value) {
        var nextValues = [value];
        var values = _this2.props.values;

        if (type === 'end') {
          nextValues = [_nth(values, 0), value];
        } else if (type === 'start') {
          nextValues = [value, _nth(values, 1)];
        }

        _this2.props.onFilterChange(nextValues);
      };
    }
  });
  Object.defineProperty(this, "handleChange", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: function value(type) {
      return function (_, value) {
        if (isNaN(+value) || !value) {
          value = undefined;
        } else {
          value = +value;
        }

        _this2.handleFilterChange(type)(value);
      };
    }
  });
  Object.defineProperty(this, "renderPicker", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: function value() {
      var _this2$props = _this2.props,
          operator = _this2$props.operator,
          values = _this2$props.values;

      if (_this2.props.isNullTypeOperator) {
        return null;
      } else if (operator === 'between') {
        return _this2.renderRangeField(values);
      }

      return _this2.renderSingleField(values);
    }
  });
  Object.defineProperty(this, "renderRangeField", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: function value(values) {
      return React.createElement(ColumnSearch, {
        operator: _this2.props.operator
      }, React.createElement(TextField, {
        type: "number",
        placeholder: "Starting Value",
        value: _nth(values, 0),
        onChange: _this2.handleChange('start'),
        onKeyDown: _this2.props.onKeyDown
      }), React.createElement(TextField, {
        type: "number",
        placeholder: "Ending Value",
        value: _nth(values, 1),
        onChange: _this2.handleChange('end'),
        onKeyDown: _this2.props.onKeyDown
      }));
    }
  });
  Object.defineProperty(this, "renderSingleField", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: function value(values) {
      var value = _nth(values, 0);

      return React.createElement(ColumnSearch, {
        operator: _this2.props.operator
      }, React.createElement(TextField, {
        type: "number",
        placeholder: "Value",
        value: value,
        onChange: _this2.handleChange(),
        onKeyDown: _this2.props.onKeyDown
      }));
    }
  });
};

export default NumericColumn;